import { render, staticRenderFns } from "./activityEdit.vue?vue&type=template&id=483f0743&scoped=true&"
import script from "./activityEdit.vue?vue&type=script&lang=ts&"
export * from "./activityEdit.vue?vue&type=script&lang=ts&"
import style0 from "./activityEdit.vue?vue&type=style&index=0&id=483f0743&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f0743",
  null
  
)

export default component.exports